import moment from 'moment';

const isEmpty = value => value === undefined || value === null || value === '';
const join = (rules) => (value, data) => rules.map(rule => rule(value, data)).filter(error => !!error)[0];

// We need to override this function because by default, two digit years above 68 are assumed to be in the 1900's and years below 68 are assumed to be in the 2000's
moment.parseTwoDigitYear = function (input) {
  return parseInt(input) + (parseInt(input) > 16 ? 1900 : 2000);
};

export const email = (value) => {
  if (!isEmpty(value) && !/(^$|^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.(?:[a-zA-Z]{2,6})$)/i.test(value)) {
    return 'Ikke korrekt epost';
  }
};

export const phone = (value) => {
  if (!isEmpty(value) && !/^\d{8}$/.test(value)) {
    return 'Ikke korrekt telefonnummer';
  }
};

export const atleastOnePhoneNumberMustBePresent = (customer = {}) => {
  if (isEmpty(customer.homePhone) && isEmpty(customer.mobilePhone)) {
    const phoneErrorMessage = 'Minst ett telefonnummer er påkrevd';
    return {
      homePhone: phoneErrorMessage,
      mobilePhone: phoneErrorMessage
    };
  }
};

export const date = (value) => {
  if (!isEmpty(value) && !moment(value, 'DD.MM.YYYY').isValid()) {
    return 'Ikke korrekt dato';
  }
};

export const maxAge = noOfYears => value => {
  const maxDate = moment().subtract(noOfYears, 'y');

  if (!isEmpty(value) && !moment(value, 'DD.MM.YYYY').isAfter(maxDate)) {
    return `Må være yngre enn ${noOfYears} år`;
  }
};

export const minAge = noOfYears => value => {
  const minDate = moment().subtract(noOfYears, 'y');

  if (!isEmpty(value) && !moment(value, 'DD.MM.YYYY').isBefore(minDate)) {
    return `Må være eldre enn ${noOfYears} år`;
  }
};

export const required = value => {
  if (isEmpty(value)) {
    return 'Påkrevd';
  }
};

export const minLength = min => value => {
  if (!isEmpty(value) && value.length < min) {
    return `Må ha minst ${min} bokstaver`;
  }
};

export const maxLength = max => value => {
  if (!isEmpty(value) && value.length > max) {
    return `Kan inneholde maks ${max} tegn`;
  }
};

export const length = length => value => {
  if (!isEmpty(value) && value.length !== length) {
    return `Må ha lengde på ${length}`;
  }
};

export const integer = value => {
  if (!isEmpty(value) && !Number.isInteger(Number(value))) {
    return 'Må være et tall';
  }
};

export const oneOf = enumeration => value => {
  if (!~enumeration.indexOf(value)) {
    return `Må være en av: ${enumeration.join(', ')}`;
  }
};

export const match = field => (value, data) => {
  if (data) {
    if (value !== data[field]) {
      return 'Matcher ikke';
    }
  }
};

export const createValidator = rules => (data = {}) => {
  const errors = {};
  Object.keys(rules).forEach((key) => {
    const rule = join([].concat(rules[key])); // concat enables both functions and arrays of functions
    const error = rule(data[key], data);
    if (error) {
      errors[key] = error;
    }
  });
  return errors;
};

export const isBoxSerialValidOrEmpty = serial => isBoxSerialValid(serial) || serial.length === 0;
export const isCardSerialValidOrEmpty = serial => isCardSerialValid(serial) || serial.length === 0;
export const isCardSerialValid = serial => isSerialNumberValid(serial) && isCardSerialNumber(serial);
export const isBoxSerialValid = serial => isSerialNumberValid(serial) && isBoxSerialNumber(serial);
export const isBoxSerialNumber = serial => serial.length === 16;
export const isCardSerialNumber = serial => serial.length === 12;
export const isSerialNumberValid = value => {

  if (value.length === 0)
    return false;
  if (/[^0-9-\s]+/.test(value))   // accept only digits, dashes or spaces 
    return false;

  let nCheck = 0;
  let nDigit = 0;
  let bEven = false;

  value = value.replace(/\D/g, "");
  for (let n = value.length - 1; n >= 0; n--) {
    let cDigit = value.charAt(n),
      nDigit = parseInt(cDigit, 10);

    if (bEven) {
      if ((nDigit *= 2) > 9) nDigit -= 9;
    }

    nCheck += nDigit;
    bEven = !bEven;
  }
  return (nCheck % 10) === 0;
}